import { render } from "./stackholder-list.vue?vue&type=template&id=9be10826&scoped=true"
import script from "./stackholder-list.vue?vue&type=script&lang=js"
export * from "./stackholder-list.vue?vue&type=script&lang=js"

import "./stackholder-list.vue?vue&type=style&index=0&id=9be10826&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9be10826"]])

export default __exports__